import type { ReactNode } from "react";
import "./TemplatesTagsAndPositionsTabs.scss";
import Tabs from "@/shared/components/generic/tabs/Tabs.tsx";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import type { SchedulePaletteView } from "@/pages/human-resources/time-management/model/schedule-view/palette/SchedulePaletteView.ts";
import useScheduleRangeOnRoute from "@/pages/human-resources/time-management/hooks/useScheduleRangeOnRoute.ts";

interface Properties {
  viewType: SchedulePaletteView;
  onTabChange: (type: SchedulePaletteView) => void;
  horizontal: boolean;
}

export default function TemplatesTagsAndPositionsTabs(
  props: Properties,
): ReactNode {
  const { t } = useTranslation("humanResources", {
    keyPrefix: "timeManagement",
  });
  const currentRange = useScheduleRangeOnRoute();
  const viewTypes: SchedulePaletteView[] = ["templates", "tags"];
  const i18nKeys = ["scheduleTemplate", "dailyTag"];
  if (currentRange === "DAY") {
    viewTypes.push("positions");
    i18nKeys.push("position");
  }

  const labels = i18nKeys.map((k) =>
    t(k, {
      count: 2,
      context: "short",
    }),
  );

  return (
    <div
      className={classNames(
        "tags-and-templates-tabs",
        props.horizontal && "horizontal",
      )}
    >
      <Tabs
        labels={labels}
        selectedIndex={viewTypes.indexOf(props.viewType)}
        onIndexChange={(i) => {
          props.onTabChange(viewTypes[i]);
        }}
      />
    </div>
  );
}
